var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FileUploader',{attrs:{"text":'Смяна на снимката',"allowedFiles":'image/jpeg, image/png'},on:{"file-upload":_vm.uploadImage}})}
var staticRenderFns = []

export { render, staticRenderFns }